export const PHONE_CARRIER_PREFIX = '/'

export const stripPrefix = (value: string): string => value.replace(/^\//, '')

export const composeCarrierValue = (suffix: string): string =>
  suffix === '' ? '' : `${PHONE_CARRIER_PREFIX}${suffix}`
